<template>
  <v-card flat>
    <h1>{{ $t("application.instructor.workplace.title") }}</h1>
    <p>{{ $t("application.instructor.workplace.info") }}</p>
    <!-- Display workplaces as a list -->
    <v-card flat class="mt-5">
      <workplaces-list
        :workplaces="workplaces"
        @item-click="clickWorkplace($event)"
        actionType="select"
        withSearch
        flat
        :model="model"
      >
        <template v-slot:custom-text="slotProps">
          ({{ slotProps.numApprenticeships }})</template
        >
      </workplaces-list>
    </v-card>
    <!--enable button if any workplace is selected and Go to next step  -->
    <NextButton
      v-if="hasDepartments($route.params.id)"
      :isDisabled="model == null || model < 0"
      class="mt-6"
      @click="nextStep"
      >{{ $t("application.company.department-title") }}</NextButton
    >
    <NextButton
      v-else
      class="mt-6"
      :isDisabled="model == null || model < 0"
      @click="nextStep"
      >{{ $t("btn.instructor-next-step") }}</NextButton
    >
    <!-- Go to previous step -->
    <BottomNav @clicked="clickBack" />
  </v-card>
</template>

<script>
import API from "@/services/api.js";
import { mapActions, mapGetters } from "vuex";
import pick from "lodash/pick";
import find from "lodash/find";
import BottomNav from "@/components/Application/BottomNav";
import NextButton from "@/components/Common/NextButton";
import WorkplacesList from "@/components/Common/Workplace/WorkplacesList";
import { CompanyRoles } from "@/components/mixins";
import { includes } from "lodash";
// @group Application-Company
// ApplicationWorkplace component
export default {
  name: "ApplicationWorkplace",

  mixins: [CompanyRoles],

  components: {
    BottomNav,
    NextButton,
    WorkplacesList,
  },

  data() {
    return {
      workplaces: [],
      dissBtn: true,
      search: "",
      model: null,
      application: null,
      fields: ["id", "workplaceId", "step"],
      instructorInfo: "",
      showAddNew: true,
    };
  },
  /**
   * @vuese
   * Used to call  initApplication function and fetchworkplaces on create
   */
  created() {
    if (!this.currentUser) return
    this.initApplication();
    this.fetchworkplaces();
  },
  
  computed: {
    ...mapGetters("currentuser", [
      "currentUser",
      "isAdministrator",
      "isDepartmentAdministrator",
    ]),
    ...mapGetters("application", ["currentStep", "selectedApplication"]),
    ...mapGetters("basic", ["hasProfessionOrientations"]),
  },
  methods: {
    ...mapActions("application", ["updateSelectedApplication"]),
    /**
     * @vuese
     * Used to Initialize application with either selected workplace or empty
     */
    initApplication() {
      //console.log("init::", this.selectedApplication)
      if (this.selectedApplication && this.selectedApplication.id) {
        this.application = pick(this.selectedApplication, this.fields);
      } else {
        this.application = Object.fromEntries(
          this.fields.map((f) => {
            return [f, null];
          })
        );
      }
      this.application.step = this.currentStep;
      if (this.application.workplaceId && this.application.workplaceId) {
        this.dissBtn = false;
      }
    },

    /**
     * @vuese
     * Used to fetch workplaces
     * @arg The argument is an integer value representing company id
     */
    fetchworkplaces() {
      if (this.selectedApplication && this.selectedApplication.companyId > 0) {
        API.getCompanyWorkspaces(Number(this.selectedApplication.companyId))
          .then((res) => {
            let depIds = this.getCurrentUserDepartmentsIds(
              this.$route.params.id,
              this.isAdministrator,
              this.isDepartmentAdministrator(this.$route.params.id),
              true
            );
            //console.log(depIds, "wp::", res.data);
            if (this.hasDepartments(this.$route.params.id) == true) {
              if(this.isAdministrator==true)
              {
                this.workplaces=res.data
              }else{
                this.workplaces = res.data.filter((r) =>
                  r.departmentIds.find((d) => includes(depIds, d)));
              }
            } else {
              this.workplaces = res.data;
            }
            if (
              this.selectedApplication.workplaceId &&
              this.selectedApplication.workplaceId > 0 && !this.model
            ) {
              this.model = this.selectedApplication.workplaceId;
            } else if (res.data && res.data.length > 0 && res.data[0].id) {
              this.model = !this.model ? null : res.data[0].id;
              this.application.workplaceId = !this.model ? null : res.data[0].id;
            }
          })
          .catch((err) => {
            console.log("errro:", err);
          })
          .finally(() => (this.isLoading = false));
      }
    },
    /**
     * @vuese
     * Used to got to a previous step or 2 steps ahead
     */
    clickBack() {
      this.model = this.workplaces.findIndex(
        (x) => x.id === this.selectedApplication.workplaceId
      );
      // Fire -1 or -2 based on if profession had an orientation or not
      // @arg The argument is a integer representing (in which step to go)

      this.$emit(
        "goToStep",
        this.selectedApplication &&
          this.selectedApplication.professionId &&
          this.hasProfessionOrientations(this.selectedApplication.professionId)
          ? "-1"
          : "-2"
      );
    },

    /**
     * @vuese
     * Used to set workplace id based on which workplace user has selected
     */
    clickWorkplace({ id }) {
      this.model = id;
      this.application.workplaceId = id;
    },
    /**
     * @vuese
     * Used to go to the next step if form is valid and update the application with new or selected workplace
     * @arg The argument is an integer value application  id and params are the selected fields
     */
    async nextStep() {
      if (
        this.selectedApplication.workplaceId > 0 &&
        this.application.workplaceId > 0 &&
        this.selectedApplication.workplaceId != this.application.workplaceId
      ) {
        this.application.instructorId = -1;
      }
      if (this.application && this.application.id) {
        API.updateApplication(this.application.id, {
          data: this.application,
        })
          .then(() => {
            /**
             * @vuese
             * Used to fetch the application based on applciation id and update the store
             * @arg The arguments are integers values representing application id
             */
            API.getApplication(this.application.id)
              .then((res) => {
                /**
                 * @vuese
                 * Used to update application in vuex store with application  selected
                 */
                this.updateSelectedApplication(res.data);
                // Fire +1
                // @arg The argument is a integer representing (in which step to go)
                if (this.hasDepartments(this.$route.params.id)) {
                  this.$emit("goToStep", "+1");
                } else {
                  this.$emit("goToStep", "+2");
                }
              })
              .catch((error) => {
                this.$events.fire("showError", this.$t("errors.form-validation"));
              });
          })
          .catch((error) => {
            this.$events.fire("showError", this.$t("errors.form-validation"));
          });
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
